import { useCallback } from 'react';
import {
  useChildTypeDataProd,
  useParentDataProd,
} from './data/useMultiAccountData';

export const useCheckMAMViewOnlyChildTypeProd = () => {
  const { data: childData, mutate: fetchChildType } = useChildTypeDataProd();

  const { data: parentData, mutate: fetchParent } = useParentDataProd();

  const isViewOnlyChild = !childData || childData.childType === 'VIEWONLY';

  const hasParent =
    parentData === undefined ||
    (parentData != null && parentData.parentUsername !== '');

  // if child is view-only and has parent, some menus and routes should not be accessible
  const isViewOnlyChildActiveProd = hasParent && isViewOnlyChild;

  /**
   * Triggers fetch to check whether the currently logged-in user is a **VIEW ONLY** child or not.
   */
  const triggerFetchChildTypeProd = useCallback(() => {
    fetchChildType();
    fetchParent();
  }, [fetchChildType, fetchParent]);

  return { isViewOnlyChildActiveProd, triggerFetchChildTypeProd };
};
